import { Select } from "@/components/common/Select/Select";
import { socialMediaPresetList } from "@/store/types/socialMediaSizePresets";
import { useSocialMediaPlatform } from "../useSocialMediaPlatform";
import { useSocialMediaPlatformPreset } from "./usePresetType";
import { translateFunc } from "@/utils/translateFunc";

const SocialMediaPresetPlatformPreset = () => {
    const { platform } = useSocialMediaPlatform();
    const { preset, handleChange: handlePresetChange } = useSocialMediaPlatformPreset();

    return (
        <>
            <div className="flex flex-col gap-4 p pt-4 pb-4 z-25">
                <Select
                    options={Object.values(socialMediaPresetList[platform.name])}
                    getOptionValue={(o) => o.name}
                    value={preset}
                    handleClick={handlePresetChange}
                    label={translateFunc("preset-type")}
                    getOptionLabel={(option) => `${option.name} (${option.dimension.width} X ${option.dimension.height})`}
                    testKey="social-media-preset"
                />
            </div>
        </>
    );
};
export default SocialMediaPresetPlatformPreset;
